function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M458.6,256l46-45c13.7-13,7.3-36-10.7-40.3l-62.6-16l17.7-62c5-17.8-11.8-34.7-29.7-29.7l-62,17.7l-16-62.7 C337.1,0.3,313.8-6.2,301,7.3l-45,46.3L211,7.3C198.4-6,175,0.1,170.7,18l-16,62.7L92.7,63C74.9,58,58.1,74.8,63,92.7l17.7,62 l-62.7,16C0.1,175-6.3,198,7.4,211l46,45l-46,45c-13.7,13-7.3,36,10.7,40.3l62.7,16l-17.7,62c-5,17.8,11.8,34.7,29.7,29.7l62-17.7 l16,62.7c4.4,18.6,27.7,24,40.3,10.7l45-46l45,46c12.5,13.5,36,7.5,40.3-10.7l16-62.7l62,17.7c17.8,5,34.7-11.8,29.7-29.7l-17.7-62 l62.6-16c18-4.3,24.4-27.4,10.7-40.3L458.6,256z M256,352.6c-53,0-96-14.3-96-32l7.1-56.7l72.5,22.3c6.4,2,18.5,4.4,32.8,0 l72.5-22.3l7.1,56.7C352,338.2,309,352.6,256,352.6z M407.2,228l-139.5,42.9c-10.2,3.1-18.9,1.4-23.4,0l-97.8-30 c-6.1,4.2-10,10.9-10.3,18.4c4.6,2.8,7.8,7.7,7.8,13.4c0,5.4-2.8,9.9-6.9,12.8l12.8,57.4c1.1,5-2.7,9.7-7.8,9.7H114 c-5.1,0-8.9-4.7-7.8-9.7l12.8-57.4c-4.1-2.9-6.9-7.4-6.9-12.8c0-5.9,3.4-10.9,8.2-13.7c0.3-8.8,3.6-16.9,8.9-23.5l-24.3-7.5 c-11.8-3.6-11.8-19.2,0-22.8l139.5-42.9c7.6-2.3,15.8-2.3,23.4,0l139.5,42.9C418.9,208.8,418.9,224.3,407.2,228z"
});

function SvgScholar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    focusable: "false",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScholar);
export default __webpack_public_path__ + "static/media/scholar.4ed15b69.svg";
export { ForwardRef as ReactComponent };